export const CREATE_SWAP_POST = 'CREATE_SWAP_POST';
export const GET_SWAP_SHIFT = 'GET_SWAP_SHIFT';
export const POSTED_SWAP_SHIFTS = 'POSTED_SWAP_SHIFTS';
export const UPDATE_SWAP = 'UPDATE_SWAP';
export const GET_AVAILABLE_SHIFTS = 'GET_AVAILABLE_SHIFTS';
export const APPLY_FOR_SHIFT = 'APPLY_FOR_SHIFT';
export const ASSIGN_FOR_SHIFT = 'ASSIGN_FOR_SHIFT';
export const DECLINE_REQUEST = 'DECLINE_SHIFT';
export const GET_USER_REQ = 'GET_USER_REQ';
